import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { FewShotPriority } from '../../ai/few-shot/priority/FewShotPriority';
import { getCurrentPriorityOrder } from '../../ai/few-shot/store';
import styles from '../Clients.module.scss';
import { getSelectedClientFewShotAgreementTypeId, setClientSelectedFewShotAgreementTypeId } from '../store';
import { Scrollable } from '../../../shared/scrollable/Scrollable';
import { getAllDocumentNames } from '../../documents/store/selectors';

interface ClientFewShotDocumentsProps {
    agreementTypeIds: number[];
}

export const ClientFewShotDocuments: React.FC<ClientFewShotDocumentsProps> = ({ agreementTypeIds }) => {
    const dispatch = useAppDispatch();
    const selectedFewShotAgreementTypeId = useAppSelector(getSelectedClientFewShotAgreementTypeId);
    const currentPriorityOrder = useAppSelector(getCurrentPriorityOrder);
    const allDocumentNames = useAppSelector(getAllDocumentNames);

    const selectAgreementType = useCallback((agreementTypeId: number) => dispatch(setClientSelectedFewShotAgreementTypeId(agreementTypeId)), [dispatch]);

    const getAgreementTypeName = useCallback((id: number) => allDocumentNames.find(({ agreementTypeId }) => agreementTypeId === id)?.agreementType || '', [allDocumentNames]);
    const getRelevantDocumentNames = useCallback((id: number) => allDocumentNames.filter(({ agreementTypeId }) => agreementTypeId === id).map(({ documentName }) => documentName), [allDocumentNames]);

    if (isNull(selectedFewShotAgreementTypeId) || Object.keys(currentPriorityOrder).length === 0) {
        return (
            <div className={styles.clientModalContentWrapper}>
                <div className={styles.clientModalHeader}>
                    <div className={styles.clientModalTitle}>Few Shot Agreement Types</div>
                </div>
                <div className={styles.agreementTypes}>
                    <Scrollable>
                        <div className={styles.tilesWrapper}>
                            {agreementTypeIds.map(agreementTypeId => {
                                const documentNames = getRelevantDocumentNames(agreementTypeId);
                                const agreementType = getAgreementTypeName(agreementTypeId);
                                return (
                                    <button key={agreementTypeId} className={styles.agreementTypeTileWrapper} onClick={() => selectAgreementType(agreementTypeId)}>
                                        <div className={styles.documentNamesHeader}>{agreementType}:</div>
                                        <div className={styles.documentNamesList}>
                                            <Scrollable>
                                                <div>
                                                    {documentNames.map((name, i) => <div className={styles.documentName} key={i}>{name}</div>)}
                                                </div>
                                            </Scrollable>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                    </Scrollable>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.clientModalContentWrapper}>
            <div className={styles.clientModalHeader}>
                <div className={styles.clientModalTitle}>Specify System Few Shot Document Priority</div>
            </div>
            <div className={styles.priorityWrapper}>
                <FewShotPriority priorityOrder={currentPriorityOrder} />
            </div>
        </div>
    );
};
